import Backbone from 'backbone'
import _ from 'lodash'
import i18n from './i18n'
import * as urlToLinks from './urls-to-links'
import template from './license-restriction-view.hbs'

/**
 * Returns a view that displays a message if a section is
 * restricted by license that advertises the function and
 * lets the user know what they need to do to enable it.
 * This is similar to license-restriction.js, which displays
 * the message in a dialog, but instead is intended to be
 * displayed in the display pane when the attempts to navigate
 * to a restricted section. #54374
 */
const LicenseRestrictionView = Backbone.View.extend({

	className: 'license-restriction-view license-restriction empty-state-body',

	render: function() {
		this.$el.html(template(this.context()))
		return this
	},

	context: function() {
		let link = this.supportEmailLink()
		let contact =  i18n.get('license.restriction.contact.email',
			link, this.options.enableType)
		let availableMessage = this.availableMessage()

		return _.extend({ contact, availableMessage }, this.options)
	},

	supportEmailLink: function() {
		return urlToLinks.createAnchor(
			'mailto:support@spiderstrategies.com','support@spiderstrategies.com')
	},

	availableMessage: function() {
		return i18n.get('license.restriction.available', this.options.enableType)
	}

})

const DatasetsRestriction = LicenseRestrictionView.extend({
	initialize: function(options = {}) {
		this.options = {
			description: i18n.get('license.restriction.datasets.description'),
			headerIcon: 'dataset-restricted-license',
			headline: i18n.get('license.restriction.datasets.headline'),
			enableType: i18n.get('license.restriction.datasets.enableType'),
			learnMore: this.learnMoreLink()
		}
	},

	learnMoreLink: function() {
		let url = 'https://support.spiderstrategies.com/hc/en-us/articles/4408591440404-Overview-of-Datasets'
		return urlToLinks.createAnchor(url, 'license.restriction.learnMore')
	}
})

const FormsRestriction = LicenseRestrictionView.extend({
	initialize: function(options = {}) {
		this.options = {
			description: i18n.get('license.restriction.forms.description'),
			headerIcon: 'form-restricted-license',
			headline: i18n.get('license.restriction.forms.headline'),
			enableType: i18n.get('license.restriction.forms.enableType'),
			learnMore: this.learnMoreLink()
		}
	},

	learnMoreLink: function() {
		let url = 'https://support.spiderstrategies.com/hc/en-us/articles/10027239661460-Overview-of-Forms'
		return urlToLinks.createAnchor(url, 'license.restriction.learnMore')
	}
})

const datasetsRestriction = () => new DatasetsRestriction()
const formsRestriction = () => new FormsRestriction()

LicenseRestrictionView.datasetsRestriction = datasetsRestriction
LicenseRestrictionView.formsRestriction = formsRestriction

export default LicenseRestrictionView
export { datasetsRestriction, formsRestriction }

LicenseRestrictionView.__filename__ = 'components/license-restriction-view.js'
